module.exports = {"110109001":"大峪街道","110109002":"城子街道","110109003":"东辛房街道","110109004":"大台街道","110109005":"王平地区","110109006":"永定地区","110109007":"龙泉地区","110109101":"潭柘寺镇","110109104":"军庄镇","110109105":"雁翅镇","110109106":"斋堂镇","110109107":"清水镇","110109108":"妙峰山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110109.json
// module id = 28
// module chunks = 0